import { requestService } from 'shared/utils/services/requestService';

export const getListingsCount = async () => {
  return requestService({
    url: `/web-api/consumer-search/get-listings-count`,
    method: 'GET',
  });
};
